import angular from 'angular';
import { MenuBarController } from './MenuBar.controller';
import template from './MenuBar.template.html';
import './MenuBar.scss';

export const menuBarModule = angular
  .module('bit.components.MenuBar', [])
  .component('bitMenuBar', {
    template,
    controller: MenuBarController,
    controllerAs: 'mbc',
  });
